import { render, staticRenderFns } from "./RewardCollection.vue?vue&type=template&id=59590189&"
import script from "./RewardCollection.vue?vue&type=script&lang=js&"
export * from "./RewardCollection.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/qcard.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports